(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8291],{

/***/ 90181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pristupnost; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Accessibility/Accessibility.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Accessibilityelements__Wrapper",
  componentId: "sc-146g4iq-0"
})(["margin-top:", ";padding:0 ", ";@media (min-width:", "px){margin-top:", ";}.title{font-size:", ";font-weight:", ";color:", ";display:block;text-align:center;padding-bottom:", ";margin-top:", ";}.subTitle{font-weight:", ";display:block;text-align:center;padding-bottom:", ";}.sectionTitle{font-size:", ";font-weight:", ";display:block;padding:", " 0;}.underline{text-decoration:underline;}.marginLeft{margin-left:", ";}.section{a{color:", ";padding-right:", ";display:inline-flex;}}"], (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf), (0,polished_esm/* rem */.hO)(30), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(65), function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(18), function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(4));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Accessibility/Accessibility.tsx




var ACCESSIBILITY_ID = 'accessibility';

var AccessibilityTemplate = function AccessibilityTemplate() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "title",
      id: "".concat(ACCESSIBILITY_ID, "-sekcia"),
      children: "Pr\xEDstupnos\u0165"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      className: "section",
      children: ["E-shop ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: "https://profivzdelavanie.sk",
        children: "profivzdelavanie.sk"
      }), " je prev\xE1dzkovan\xFD s\xA0d\xF4razom na\xA0pr\xEDstupnos\u0165 pre\xA0v\u0161etk\xFDch pou\u017E\xEDvate\u013Eov. V\xA0s\xFAlade so\xA0z\xE1konom \u010D.\xA0351/2022 Z.\u202Fz. o\xA0pr\xEDstupnosti v\xFDrobkov a\xA0slu\u017Eieb informujeme, \u017Ee niektor\xE9 na\u0161e slu\u017Eby, elektronick\xE9 produkty a\xA0syst\xE9my vznikli pred\xA0\xFA\u010Dinnos\u0165ou predmetn\xE9ho z\xE1kona a\xA0vyu\u017E\xEDvaj\xFA z\xE1konn\xE9 ", /*#__PURE__*/(0,jsx_runtime.jsx)("b", {
        children: "prechodn\xE9 obdobie do\xA028.\xA06.\xA02030"
      }), "."]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Akt\xEDvne pracujeme na\xA0moderniz\xE1cii a \xFAprave digit\xE1lneho obsahu, aby sme zabezpe\u010Dili jeho zrozumite\u013Enos\u0165, ovl\xE1date\u013Enos\u0165 a\xA0kompatibilitu s\xA0asisten\u010Dn\xFDmi technol\xF3giami (\u010D\xEDta\u010Dky obrazovky, ovl\xE1danie kl\xE1vesnicou a\xA0pod.)."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Pokia\u013E naraz\xEDte na\xA0obsah, ktor\xFD nie je pr\xEDstupn\xFD, alebo potrebujete pomoc so\xA0z\xEDskan\xEDm inform\xE1ci\xED v pr\xEDstupnej forme, pros\xEDm, kontaktujte n\xE1s."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("b", {
        children: "Kontakt:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      className: "section",
      children: ["E-mail: ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: "mailto:profivzdelavanie@pp.sk",
        children: "profivzdelavanie@pp.sk"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Tel.: ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: "tel:041/70 53 888",
        children: "041/70 53 888"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Adresa: Poradca podnikate\u013Ea, s.\u202Fr.\u202Fo., Martina R\xE1zusa 23A, 010 01 \u017Dilina"]
    })]
  });
};

/* harmony default export */ var Accessibility_Accessibility = (AccessibilityTemplate);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 3 modules
var Footer = __webpack_require__(94951);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx + 2 modules
var Header = __webpack_require__(50866);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
;// CONCATENATED MODULE: ./src/pages/pristupnost.tsx










var Accessibility = function Accessibility() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      withPadding: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Accessibility_Accessibility, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

/* harmony default export */ var pristupnost = (Accessibility);

/***/ }),

/***/ 96180:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pristupnost",
      function () {
        return __webpack_require__(90181);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77191:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectDestructuringEmpty; }
/* harmony export */ });
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

/***/ }),

/***/ 90116:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(52587);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(28811);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,iterableToArray/* default */.Z)(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4623,9774,2888,179], function() { return __webpack_exec__(96180); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);